import { useState } from "react";
import AddCustomerFormModal from "../forms/admin/AddCustomerFormModal";
import CustomerTable from "../forms/admin/customerTable";
import CustomerViewModal from "../forms/admin/customerViewModal";

const CustomerAdministrationComponent = () => {
    const [showForm, setShowForm] = useState(false);
    const [showView, setShowView] = useState(false);
    const [customerData, setCustomerData] = useState({});
    const [isEdit, setIsEdit] = useState(false);

    const customerView = (customerData) => {
        setShowView(true);
        setShowForm(false);
        setCustomerData(customerData);
    }

    const customerEdit = (customerData) => {
        setShowForm(true);
        setShowView(false);
        setIsEdit(true);
        setCustomerData(customerData);
    }

    return (
        <>
            <div className="dashboard-header">
                <h4 className="welcomeText">Customer Administration</h4>
                <button className="add-request" onClick={()=>{ setIsEdit(false); setCustomerData({}); setShowForm(!showForm) }}>Add New Customer</button>
            </div>
            <AddCustomerFormModal isEdit={isEdit} customerData={customerData} show={showForm} onClose={() => setShowForm(false)} />
            <CustomerViewModal show={showView} customerData={customerData} onClose={() => setShowView(false)}/>
            <CustomerTable onCustomerView={customerView} onCustomerEdit={customerEdit}/>
        </>
    );
};

export default CustomerAdministrationComponent;